






























import Vue from 'vue';
import {Component, Prop, Provide} from "vue-property-decorator";

const test = require('../../public/img/W100812182.jpg');

@Component
export default class CarItemC extends Vue {

    @Prop()
    inline?: boolean;

    @Provide()
    test = test;

    get classes() {
        return 'thumbnail ' + (this.inline ? 'thumbnail-inline' : '');
    }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CarItemC.vue